<div class="intro">
  <!-- LOGO -->
  <div class="intro__logo">
    <svg viewBox="0 0 512 256">
      <use [attr.xlink:href]="'assets/images/logo.svg#svg1'"></use>
    </svg>
  </div>
  <!-- TITLE -->
  <div class="intro__title">
    {{userReceived ? 'all good, loading your data' : 'checking your access'}}
    <mat-progress-bar [mode]="'indeterminate'"></mat-progress-bar>
  </div>
</div>
